module.exports = __webpack_public_path__ + "img/logo PO.f0d35688.png";